import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Link } from 'components/link/Link';
import { Banner } from 'components/banner/Banner';

import s from './Consent.scss';

interface IProps {
  children?: React.ReactNode;
}

export const Consent = ({ children }: IProps) => {
  const [visible, setVisible] = useState(false);

  const readCookie = () => {
    return document.cookie.includes('gdprConsent');
  };

  const setCookie = () => {
    if (!readCookie()) {
      const d = new Date();
      d.setFullYear(d.getFullYear() + 10);
      document.cookie = `gdprConsent=true; expires=${d}`;
    }

    setVisible(false);
  };

  useEffect(() => {
    setVisible(!readCookie());
  }, []);

  const intl = useIntl();

  const isEnglish = intl.locale.toLowerCase() === 'en-us';

  const link = <Link to="https://www.cookiehub.com/about-cookies">
    {intl.formatMessage({ id: 'consent.linkText', defaultMessage: 'Samþykkja' })}
  </Link>

  return (
    <Banner
      visible={visible}
      label={intl.formatMessage({ id: 'consent.label', defaultMessage: 'Samþykki' })}
    >
      <div className={s.consent}>
        <div className={s.consent__text}>
          {intl.formatMessage({
            id: 'consent.body',
            defaultMessage: `Þessi vefur notar vafrakökur (e. cookies)
            til að tryggja sem bestaupplifun af notkun vefsins.`
          })}
          {' '}{link}
        </div>
        <div className={s.consent__actions}>
          <button
            className={s.consent__button}
            onClick={() => {
              setCookie();
            }}
          >
            {intl.formatMessage({ id: 'consent.accept', defaultMessage: 'Samþykkja' })}
          </button>
        </div>
      </div>
    </Banner>
  );
};
